import { AppModalBase } from 'app/types/appModal.types';

export type RewindModal = AppModalBase<
  'app:rewind',
  {
    /** The user ID to fetch rewind data for. */
    userId: string;
  },
  never
>;

export type RewindSlideProps = {
  /** When true, skip animations and show the final state (for revisited slides) */
  isCompleted?: boolean;
  /** Callback when slide animation completes - pass the slide id */
  onComplete?: (slideId: RewindSlideId) => void;
  /** Callback to fade music to a target volume */
  onFadeMusic?: (targetVolume: number, durationMs?: number) => void;
};

export type RewindSlideId = (typeof REWIND_SLIDES)[number];

export const REWIND_SLIDES = [
  'opening',
  'journey',
  'impact',
  'style',
  'wins',
  'closing',
] as const;
